<div class="w-full h-full flex flex-col py-6 px-6">
  <!-- Options bar -->
  <div class="flex items-end justify-between mb-3">
    <div class="flex items-center flex-wrap gap-4">
      <div *ngIf="scanners" class="w-[350px]">
        <mat-select class="filter-select" [formControl]="filter_scanners" multiple placeholder="Filter by Scanner">
            <mat-option *ngFor="let scanner of scanners" [value]="scanner.Id">
            {{ scanner.Name }}
            </mat-option>
        </mat-select>
      </div>
      <div *ngIf="customers" class="w-[220px]">
        <mat-select class="filter-select" [formControl]="filter_customers" multiple placeholder="Filter by Customer">
            <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{ customer.name }}
            </mat-option>
        </mat-select>
      </div>
      <div class="flex items-center gap-3">
        <input type="checkbox" class="w-5 h-5 dark-checkbox" [(ngModel)]="only_active">
        <p class="text-sm text-white">Only show active users</p>
      </div>
    </div>
    <div class="flex justify-end items-end dark:text-gray-300 text-sm">
        <button type="button" class="ml-2 dark-btn min-w-[125px]" (click)="clear_filters()">
          <i class="fa-solid fa-xmark mr-1 dark:text-green-600"></i> Clear Filters
        </button>
        <button type="button" class="ml-2 dark-btn min-w-[105px]" (click)="refresh()">
          <i class="fa-solid fa-fw fa-sync mr-1 dark:text-green-600"></i> Refresh
        </button>
    </div>
  </div>


  <!-- Grid -->
  <ag-grid-angular
    class="flex-1 w-full h-[600px]"
    [theme]="theme"
    [gridOptions]="grid.options"
    [columnDefs]="grid.columnDefs"
    [rowData]="data"
    [statusBar]="grid.statusBar"
    (gridReady)="on_grid_ready($event)"
    (modelUpdated)="on_model_updated($event)"
    (rowSelected)="on_row_selected($event)"
  />
</div>

<div *ngIf="user_data_modal" class="w-full h-full fixed top-0 right-0 z-45 bg-app-black-100/90 flex items-start justify-center">
  <div class="agreement-popup relative w-8/10 max-w-[950px] p-6 pb-12 card flex flex-col items-center bg-white mt-25 overflow-y-auto">
    <i (click)="close_user_data_modal()" class="absolute fa-solid fa-xmark text-2xl opacity-30 cursor-pointer hover:opacity-100 top-2 right-2"></i>
    <h2 class="text-2xl font-bold">Agreement Info</h2>
    <div *ngIf="user_exchange_data as data" class="w-full mt-10 agreement-data">
      <div class="row">
        <div class="item">
          <p>Email</p>
          <input type="text" [value]="data.email" disabled>
        </div>
        <div class="item">
          <p>First Name</p>
          <input type="text" [value]="data.first_name" disabled>
        </div>
        <div class="item">
          <p>Last Name</p>
          <input type="text" [value]="data.last_name" disabled>
        </div>
        <div class="item">
          <p>Phone</p>
          <input type="text" [value]="data.phone" disabled>
        </div>
      </div>
      <div class="row">
        <div class="item" *ngIf="data.address">
          <p>Address</p>
          <input type="text" [value]="data.address" disabled>
        </div>
        <div class="item">
          <p>City</p>
          <input type="text" [value]="data.city" disabled>
        </div>
        <div class="item" *ngIf="data.state">
          <p>State</p>
          <input type="text" [value]="data.state" disabled>
        </div>
        <div class="item" *ngIf="data.zip_code">
          <p>Zip</p>
          <input type="text" [value]="data.zip_code" disabled>
        </div>
        <div class="item" *ngIf="data.country">
          <p>Country</p>
          <input type="text" [value]="data.country" disabled>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <p>Occupation</p>
          <input *ngIf="data.occupation" type="text" [value]="data.occupation" disabled>
          <input *ngIf="data.other_employment" type="text" [value]="data.other_employment" disabled>
        </div>
        <div class="item" *ngIf="data.job_title">
          <p>Job Title</p>
          <input type="text" [value]="data.occupation" disabled>
        </div>
        <div class="item" *ngIf="data.employer.name">
          <p>Employer</p>
          <input type="text" [value]="data.employer.name" disabled>
        </div>
      </div>
      <div class="row" *ngIf="data.employment_function">
        <div class="item">
          <p>Employment Function</p>
          <input type="text" [value]="data.employment_function" disabled>
        </div>
      </div>
      <div class="row" *ngIf="data.employment_status === 'employed'">
        <div class="item" *ngIf="data.employer.address">
          <p>Emp Address</p>
          <input type="text" [value]="data.employer.address" disabled>
        </div>
        <div class="item" *ngIf="data.employer.city">
          <p>Emp City</p>
          <input type="text" [value]="data.employer.city" disabled>
        </div>
        <div class="item" *ngIf="data.employer.state">
          <p>Emp State</p>
          <input type="text" [value]="data.employer.state" disabled>
        </div>
        <div class="item" *ngIf="data.employer.zip_code">
          <p>Emp Zip</p>
          <input type="text" [value]="data.employer.zip_code" disabled>
        </div>
        <div class="item" *ngIf="data.employer.country">
          <p>Emp Country</p>
          <input type="text" [value]="data.employer.country" disabled>
        </div>
      </div>
      <div class="flex flex-col gap-7" *ngIf="data.questions as questions">
        <div *ngFor="let question of data_questions">
          <p class="mb-2">{{ question.label }}</p>
          <p class="font-bold uppercase">
            {{ questions[question.id] }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>